import React, {useState, useEffect} from 'react'
import {Outlet, useOutletContext} from 'react-router-dom'
import ToolsContainer from '../components/tools-page/tools-container'
import {TabToggle} from '../accountManagement/shared/Tabs'
import {ToolsPageWrapper} from '../components/tools-page/styled'
import {TOOL_SECTIONS} from '../components/tools-page/tools-consts'

const TOOLS_TABS = TOOL_SECTIONS.map(s => ({label: s.label, path: s.path}))

const ToolsPage = () => {
  const [repIdValue, setRepIdValue] = useState('')

  useEffect(() => {
    const url = new URL(window.location.href)
    setRepIdValue(url.searchParams.get('rep_id'))
  }, [])

  return (
    <ToolsPageWrapper>
      <TabToggle
        tabs={TOOLS_TABS}
        background="#fff"
        border="1px solid #e5e7eb"
        borderRadius="999px"
      />
      <Outlet context={{repIdValue}} />
    </ToolsPageWrapper>
  )
}

const ToolsContent = ({section}) => {
  useOutletContext()
  return <ToolsContainer section={section} />
}

export {ToolsPage, ToolsContent}
